import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Clock, Zap } from "lucide-react";
import { eur } from "../api";

export default function ServiceCard({ service }) {
  const navigate = useNavigate();
  const base = service.category === "guidance" ? "/guidances" : "/energetique";
  const isSos = service.slug === "sos-sorciere";
  return (
    <article
      data-testid={`service-card-${service.slug}`}
      onClick={() => navigate(`${base}/${service.slug}`)}
      className="card-soft card-hover p-6 sm:p-7 cursor-pointer flex flex-col"
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <h3 className="font-serif text-2xl font-semibold text-[#5A3A4B] flex items-center gap-2">
          {service.name}
          {isSos && <Zap size={18} className="text-[#C9A56A]" />}
        </h3>
        {service.badge && <span className="badge-gold shrink-0">{service.badge}</span>}
      </div>
      {service.category !== "guidance" && service.subtitle && (
  <p className="text-sm text-[#7A5D58] leading-relaxed mb-4 flex-1">
    {service.subtitle}
  </p>
)}
      <div className="flex items-center gap-3 text-[#7A5D58] text-xs mb-5">
        {service.duration_minutes ? (
          <span className="inline-flex items-center gap-1.5">
            <Clock size={14} /> {service.duration_minutes} minutes
          </span>
        ) : null}
      </div>
      <div className="flex items-center justify-between pt-4 border-t border-[#7A5D58]/10">
        <span className="font-serif text-2xl font-semibold text-[#5A3A4B]">{eur(service.price_cents)}</span>
        <span className="inline-flex items-center gap-1.5 text-sm font-medium text-[#5A3A4B]">
          Découvrir <ArrowRight size={15} />
        </span>
      </div>
    </article>
  );
}
